module.exports = __webpack_public_path__ + "static/media/instagram1.a407702b.svg";